module.exports = __webpack_public_path__ + "img/JMC-LOGO-BLACK.17141579.png";